import { Link } from 'react-router-dom';
import { Lightning, ArrowLeft, Warning } from '@phosphor-icons/react';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center p-6" data-testid="not-found-page">
      <div className="text-center max-w-md">
        <div className="text-[120px] font-black font-['Barlow_Condensed'] text-[#FF3B30] leading-none mb-4">404</div>
        <h1 className="text-3xl font-black tracking-tighter mb-3">PAGE NOT FOUND</h1>
        <p className="text-[#A1A1AA] mb-8">
          The page you're looking for doesn't exist or has been moved.
          Let's get you back on track.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/" className="btn-primary px-6 py-3 flex items-center justify-center gap-2">
            <Lightning weight="fill" className="w-5 h-5" /> Go Home
          </Link>
          <Link to="/dashboard" className="btn-secondary px-6 py-3 flex items-center justify-center gap-2">
            <ArrowLeft weight="bold" className="w-5 h-5" /> Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
